import PcnService from './service';
import { AddNonPcnRequest, AddNonPcnResponseData, UpdateNonPcnRequestData } from './types';
import { getAppStore } from '@src/utils/store-reference';
import { RequestStatus, RequestType, StorageScopes } from '@src/utils/enums';
import { useApp, useJpa, useNonPcn } from '@src/stores';
import { queryClient } from '@src/api/queryClient';
import { PROJECT_QUERY_KEYS } from '@src/api/services/project';

export class NonPcnMutations {
  public static readonly addNonPcn = async (payload: AddNonPcnRequest): Promise<AddNonPcnResponseData> => {
    const store = getAppStore();
    const { setNonPcnRequest } = useNonPcn.getState();
    const { setIsLoading } = useApp.getState();
    const { resetToDefaults } = useJpa.getState();

    resetToDefaults();

    setIsLoading(true, `Loading ${RequestType.NonPreconstructionNotification} Form`);

    const { data } = await PcnService.addNonPcn(payload);

    store.doUpdateRequestAPIData({
      projectID: data.projectID,
      projectVersion: data.projectVersion,
      request: { requestID: data.requestID, permission: data.permission },
    });
    store.doUpdateRequestData({
      projectID: data.projectID,
      projectVersion: data.projectVersion,
      request: { requestID: data.requestID },
    });
    store.doUpdateRequestObject({
      requestStatus: RequestStatus.Draft,
      requestType: RequestType.NonPreconstructionNotification,
      requestID: data.requestID,
    });
    queryClient.invalidateQueries({
      queryKey: [
        PROJECT_QUERY_KEYS.GET_SHARED_CONTACTS,
        store.selectProjectID(),
        store.selectRequestID(),
        store.selectVersion(),
      ],
    });
    useJpa.setState({ jpaBasicInfo: data?.jpaBasicInfo });
    setNonPcnRequest({ nonPcnRequestID: data.nonPcnRequestID });
    store.doFetchUserFilesDetails({ componentID: data.nonPcnRequestID, scope: StorageScopes.ProjectFolder });
    setIsLoading(false);
    return data;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static readonly updateNonPcn = async (payload: any): Promise<UpdateNonPcnRequestData> => {
    const response = await PcnService.updateNonPcn(payload);
    return response;
  };
}
